/**
 * Header [New] — mega menu, mobile drawer, sticky/transparent, Impulse cart/search
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'header-new';
  var MQ_DESKTOP = '(min-width: 1024px)';

  function isDesktop() {
    return window.matchMedia(MQ_DESKTOP).matches;
  }

  function initCartDrawer() {
    if (window.__vgHeaderCartInit) return;
    if (typeof theme === 'undefined' || !theme.CartDrawer) return;
    if (!theme.settings || theme.settings.cartType !== 'drawer') return;
    if (document.body.classList.contains('template-cart')) return;
    if (!document.getElementById('CartDrawer')) return;
    window.__vgHeaderCartInit = true;
    try {
      new theme.CartDrawer();
    } catch (e) {
      window.__vgHeaderCartInit = false;
    }
  }

  function initAnnouncementBar() {
    if (typeof theme === 'undefined' || !theme.announcementBar || !theme.announcementBar.init) return;
    try {
      theme.announcementBar.init();
    } catch (e) {
      /* already initialized */
    }
  }

  function wireSearch(root, onOpen) {
    if (root._vgSearchWired) return;
    root._vgSearchWired = true;

    root.querySelectorAll('.js-search-header').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (typeof onOpen === 'function') onOpen();
        document.dispatchEvent(
          new CustomEvent('predictive-search:open', {
            detail: { context: 'header' },
            bubbles: true,
          })
        );
        document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
        var container = root.querySelector('.site-header__search-container');
        if (container) container.classList.add('is-active');
      });
    });

    document.addEventListener('predictive-search:close-all', function () {
      var container = root.querySelector('.site-header__search-container');
      if (container) container.classList.remove('is-active');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
    });
  }

  function enhance(root) {
    if (!root || root._vgHeaderReady) return;
    root._vgHeaderReady = true;

    var shell = root.querySelector('[data-vg-header-shell]');
    var spacer = root.querySelector('[data-vg-header-spacer]');
    var triggers = root.querySelectorAll('[data-vg-mega-trigger]');
    var panels = root.querySelectorAll('[data-vg-mega-panel]');
    var drawer = root.querySelector('[data-vg-mobile-drawer]');
    var openBtn = root.querySelector('[data-vg-mobile-open]');
    var closeBtn = root.querySelector('[data-vg-mobile-close]');
    var overlayEnabled = root.getAttribute('data-overlay') === 'true';
    var stickyEnabled = root.getAttribute('data-sticky') === 'true';
    var activeKey = null;
    var closeTimer = null;

    function announcementTop() {
      var ann = document.querySelector('.announcement-bar');
      if (!ann) return 0;

      if (ann.classList.contains('announcement-bar--sticky')) {
        var impulse = getComputedStyle(document.body)
          .getPropertyValue('--sticky-announcement-bar-height')
          .trim();
        if (impulse && impulse !== '0px') return parseFloat(impulse) || ann.offsetHeight;
        return ann.offsetHeight;
      }

      return Math.max(0, Math.round(ann.getBoundingClientRect().bottom));
    }

    function syncStickyMetrics() {
      if (!stickyEnabled) return;
      root.style.setProperty('--vg-hdr-sticky-top', announcementTop() + 'px');
      if (!shell || !spacer) return;
      var h = shell.offsetHeight;
      spacer.style.height = overlayEnabled ? '0px' : h + 'px';
    }

    function setScrolled() {
      if (overlayEnabled) {
        root.classList.toggle('is-scrolled', (window.scrollY || 0) > 24);
      } else if (stickyEnabled) {
        root.classList.add('is-scrolled');
      }
      syncStickyMetrics();
    }

    function closeMega() {
      activeKey = null;
      root.classList.remove('is-mega-open');
      triggers.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('is-open');
        p.hidden = true;
      });
    }

    function openMega(key) {
      if (!isDesktop()) return;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      activeKey = key;
      root.classList.add('is-mega-open');
      triggers.forEach(function (t) {
        var on = t.getAttribute('data-vg-mega-trigger') === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-vg-mega-panel') === key;
        if (on) {
          p.hidden = false;
          void p.offsetWidth;
          p.classList.add('is-open');
        } else {
          p.classList.remove('is-open');
          p.hidden = true;
        }
      });
    }

    triggers.forEach(function (t) {
      var key = t.getAttribute('data-vg-mega-trigger');
      t.addEventListener('mouseenter', function () {
        openMega(key);
      });
      t.addEventListener('focus', function () {
        openMega(key);
      });
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (activeKey === key) closeMega();
        else openMega(key);
      });
    });

    // Leaf nav links (e.g. Jewelry) have no mega — close any open panel on hover/focus
    root.querySelectorAll('.vg-header__nav-link').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        closeMega();
      });
      link.addEventListener('focus', function () {
        closeMega();
      });
    });

    if (shell) {
      shell.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(closeMega, 80);
      });
      shell.addEventListener('mouseenter', function () {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      });
    }

    function openDrawer() {
      if (!drawer) return;
      closeMega();
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.classList.add('vg-header-drawer-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('vg-header-drawer-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 350);
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeDrawer);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMega();
        closeDrawer();
      }
    });

    window.addEventListener(
      'resize',
      function () {
        syncStickyMetrics();
        if (isDesktop()) closeDrawer();
        else closeMega();
      },
      { passive: true }
    );
    window.addEventListener('scroll', setScrolled, { passive: true });

    root.classList.toggle('is-scrolled', !overlayEnabled);
    setScrolled();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(syncStickyMetrics);
      var ann = document.querySelector('.announcement-bar');
      if (ann) ro.observe(ann);
      if (shell) ro.observe(shell);
    }

    wireSearch(root, closeMega);
    initCartDrawer();
    initAnnouncementBar();
    window.setTimeout(syncStickyMetrics, 150);
    window.addEventListener('load', setScrolled);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target.querySelector &&
        event.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')) ||
      null;
    if (!root && event.target.getAttribute && event.target.getAttribute('data-section-type') === SECTION_TYPE) {
      root = event.target;
    }
    if (root) {
      root._vgHeaderReady = false;
      enhance(root);
    }
  });
})();
